export default __webpack_public_path__ + "static/near-collision-fbc78b851de11eb5600d3c2e22cc19f6.png";